import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Path } from '@shared-enums';

export const routes: Routes = [
  {
    path: Path.Blank,
    loadComponent: () =>
      import('./core/components/side-navigation/side-navigation.component').then(
        c => c.SideNavigationComponent,
      ),
    canActivate: [MsalGuard],
    children: [
      {
        path: Path.Bicycles,
        loadComponent: () =>
          import('./features/bicycles/pages').then(c => c.BicyclesComponent),
      },
      {
        path: Path.AdditionalGear,
        loadComponent: () =>
          import('./features/additional-gear/pages').then(c => c.AdditionalGearComponent),
      },
      {
        path: Path.ArticleList,
        loadComponent: () =>
          import('./features/articles/pages').then(c => c.ArticlesComponent),
      },
      {
        path: Path.ArticleCategories,
        loadComponent: () =>
          import('./features/article-category/pages').then(
            c => c.ArticleCategoryComponent,
          ),
      },
      {
        path: Path.ArticlePrices,
        loadComponent: () =>
          import('./features/article-prices/pages').then(c => c.ArticlePricesComponent),
      },
      {
        path: Path.CyclingTours,
        loadComponent: () =>
          import('./features/cycling-tours/pages').then(c => c.CyclingToursComponent),
      },
      {
        path: Path.CyclingPaths,
        loadComponent: () =>
          import('./features/cycling-paths/pages').then(c => c.CyclingPathsComponent),
      },
      {
        path: Path.GPSLink,
        loadComponent: () =>
          import('./features/gps-link/pages').then(c => c.GpsLinkComponent),
      },
      {
        path: Path.AccountManagement,
        loadComponent: () =>
          import('./features/user-accounts/pages').then(
            c => c.AccountManagementComponent,
          ),
      },
      {
        path: Path.Pedals,
        loadComponent: () =>
          import('./features/codebooks/pedals/pages').then(c => c.PedalsComponent),
      },
      {
        path: Path.BikeCategories,
        loadComponent: () =>
          import('./features/codebooks/bike-categories/pages').then(
            c => c.BikeCategoriesComponent,
          ),
      },
      {
        path: Path.ReservationDuration,
        loadComponent: () =>
          import('./features/codebooks/reservation-duration/pages').then(
            c => c.ReservationDurationComponent,
          ),
      },
      {
        path: Path.VAT,
        loadComponent: () =>
          import('./features/codebooks/vat/pages').then(c => c.VatComponent),
      },
      {
        path: Path.WorkingHours,
        loadComponent: () =>
          import('./features/codebooks/working-hours/pages').then(
            c => c.WorkingHoursComponent,
          ),
      },
      {
        path: Path.RentalDuration,
        loadComponent: () =>
          import('./features/codebooks/rental-duration/pages').then(
            c => c.RentalDurationComponent,
          ),
      },
      {
        path: Path.PriceList,
        loadComponent: () =>
          import('./features/codebooks/price-list/pages').then(c => c.PriceListComponent),
      },
      {
        path: Path.GearPriceList,
        loadComponent: () =>
          import('./features/codebooks/gear-price-list/pages').then(
            c => c.GearPriceListComponent,
          ),
      },
      {
        path: Path.RentalDurationSunbeds,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/rental-duration-sunbeds/pages').then(
            c => c.RentalDurationSunbedsComponent,
          ),
      },
      {
        path: Path.ReservationDurationSunbeds,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/reservation-duration-sunbeds/pages').then(
            c => c.ReservationDurationSunbedsComponent,
          ),
      },
      {
        path: Path.MicroLocations,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/micro-location/pages').then(
            c => c.MicroLocationComponent,
          ),
      },
      {
        path: Path.Zones,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/zone/pages').then(c => c.ZoneComponent),
      },
      {
        path: Path.AllPaymentFooters,
        loadComponent: () =>
          import('./features/payment-footer/pages').then(c => c.PaymentFooterComponent),
      },
      {
        path: Path.SunbedTypes,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/sunbed-types/pages').then(
            c => c.SunbedTypesComponent,
          ),
      },
      {
        path: Path.PriceListSunbeds,
        loadComponent: () =>
          import('./features/codebooks-sunbeds/price-list-sunbeds/pages/').then(
            c => c.PriceListSunbedsComponent,
          ),
      },
      {
        path: Path.DocumentTypes,
        loadComponent: () =>
          import('./features/codebooks/document-types/pages').then(
            c => c.DocumentTypesComponent,
          ),
      },
      {
        path: Path.RentalNote,
        loadComponent: () =>
          import('./features/codebooks/rental-note/pages').then(
            c => c.RentalNoteComponent,
          ),
      },
      {
        path: Path.SearchEngineOptimization,
        loadComponent: () => import('./features/seo/pages').then(c => c.SeoComponent),
      },
    ],
  },
  {
    path: Path.Login,
    loadComponent: () => import('./shared/components').then(c => c.LoginComponent),
  },
  {
    path: Path.Logout,
    loadComponent: () => import('./shared/components').then(c => c.LogoutComponent),
  },
  {
    path: Path.WildCard,
    redirectTo: Path.Bicycles,
    pathMatch: 'full',
  },
];
